"use strict";
/*
Copyright 2020 Splunk Inc.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.initWebVitals = void 0;
const core_1 = require("@opentelemetry/core");
const web_vitals_1 = require("web-vitals");
const reported = {};
function report(tracer, name, metric) {
    if (reported[name]) {
        return;
    }
    reported[name] = true;
    const value = metric.value;
    const now = (0, core_1.hrTime)();
    const span = tracer.startSpan('webvitals', { startTime: now });
    span.setAttribute(name, value);
    span.end(now);
}
function initWebVitals(provider) {
    const tracer = provider.getTracer('webvitals');
    // CLS is defined as being sent more than once, easier to just ensure that everything is sent just on the first occurence.
    (0, web_vitals_1.getFID)((metric) => {
        report(tracer, 'fid', metric);
    });
    (0, web_vitals_1.getCLS)((metric) => {
        report(tracer, 'cls', metric);
    });
    (0, web_vitals_1.getLCP)((metric) => {
        report(tracer, 'lcp', metric);
    });
}
exports.initWebVitals = initWebVitals;
//# sourceMappingURL=webvitals.js.map